export default "__VITE_ASSET__BLdwabDO__"